import { FC, useEffect, useState } from 'react';
import styles from './Categories.module.scss';
import { SectionTitle } from '../../../../SectionTitle/SectionTitle';
import { ShowMoreButton } from '../../../../ShowMoreButton/ShowMoreButton';
import { IGetCategoriesResponse } from '../../../../../types/categories';
import { useGetCategories } from '../../../../../queries/categories/useGetCategories';
import { generateImageUrl } from '../../../../../helpers/generateImageUrl';
import { Link } from 'react-router-dom';

export interface ICategories {}

const Categories: FC<ICategories> = () => {
  const { categoriesData, isGetCategoriesSuccess, setPage, page } =
    useGetCategories({
      'where[isActive][equals]': 'true',
    });
  const [items, setItems] = useState<IGetCategoriesResponse['docs']>([]);

  useEffect(() => {
    if (categoriesData?.docs && isGetCategoriesSuccess) {
      if (page === 1) return setItems(categoriesData.docs);

      setItems((prev) => [...prev, ...categoriesData.docs]);
    }
  }, [categoriesData?.docs, isGetCategoriesSuccess, page]);

  if (items.length === 0) return null;

  return (
    <div className={styles.Categories}>
      <SectionTitle className={styles.title}>
        <h2>Категории</h2>
      </SectionTitle>
      <div className={styles.wrapper}>
        {items.map((item) => (
          <Link
            to={`/catalog`}
            state={{ category: item.id }}
            key={item.id}
            className={styles.category}
          >
            <img
              src={
                item.image?.s3Key
                  ? generateImageUrl(item.image?.s3Key)
                  : '/images/placeholderImage.png'
              }
              className={styles.image}
              alt={item.name}
            />
            <span className={styles.categoryName}>{item.title}</span>
          </Link>
        ))}
      </div>
      {categoriesData?.hasNextPage && (
        <div className={styles.buttonWrapper}>
          <ShowMoreButton onClick={() => setPage((prev) => ++prev)}>
            Больше категорий (10)
          </ShowMoreButton>
        </div>
      )}
    </div>
  );
};

export default Categories;
